// Generated with util/create-component.js
import React from 'react';

import { IFormFieldSetProps } from './FieldSet.types';

import './FieldSet.scss';

const FieldSet = ({ children }: IFormFieldSetProps) => (
  <fieldset className="rrui-form__fieldset">{children}</fieldset>
);

export default FieldSet;
